/* Credit meter (rule 42, spec 6.10): amber at 80% used, red at 95%, limit card when exhausted.
   BYOK shows "Your key" and no credit cost. */
import { cx } from './cx';

export type MeterState = 'normal' | 'warn' | 'danger' | 'exhausted' | 'byok';

export function meterState(used: number, allowance: number, byok = false): MeterState {
  if (byok) return 'byok';
  if (allowance <= 0) return 'exhausted';
  const r = used / allowance;
  if (r >= 1) return 'exhausted';
  if (r >= 0.95) return 'danger';
  if (r >= 0.8) return 'warn';
  return 'normal';
}

export interface CreditMeterProps {
  used: number;
  allowance: number;
  resetLabel?: string;
  addon?: number;
  byok?: boolean;
  compact?: boolean;
  onClick?: () => void;
}

export function CreditMeter({ used, allowance, resetLabel, addon, byok, compact, onClick }: CreditMeterProps) {
  const st = meterState(used, allowance, byok);
  const left = Math.max(0, allowance - used);
  const pctLeft = allowance > 0 ? Math.round((left / allowance) * 100) : 0;
  const title = byok ? 'Your key' : `${left.toLocaleString()} of ${allowance.toLocaleString()} credits left`;
  const sub = byok ? 'No credit cost for model calls' : [resetLabel && `Resets ${resetLabel}`, addon ? `+${addon.toLocaleString()} add-on` : ''].filter(Boolean).join(' · ');
  return (
    <button type="button" className={cx('meter', st)} onClick={onClick} data-cap="BILL-02" aria-label={`Credits: ${title}${sub ? `. ${sub}` : ''}`} data-state={st}>
      <span className="ring" style={{ ['--p' as string]: byok ? 100 : pctLeft }} aria-hidden="true"><span>{byok ? 'KEY' : `${pctLeft}%`}</span></span>
      {!compact && (
        <span className="meter-text">
          <b>{title}</b>
          {sub && <small>{st === 'warn' ? 'Running low · ' : st === 'danger' ? 'Almost out · ' : st === 'exhausted' ? 'Limit reached · ' : ''}{sub}</small>}
        </span>
      )}
    </button>
  );
}
